/**
 * Burbank Analysis: white-dot overlays compare CAP bars to ClimatePlans SoCal Gas (physical series).
 * Residential and commercial use different year sets (residential omits 2021/2023 per product review).
 */
export const BURBANK_SOCAL_GAS_RESIDENTIAL_OVERLAY_YEARS = new Set([2022, 2024]);
/** 2021 commercial SoCal filing omitted from harmonized series (CAP-interpolated). */
export const BURBANK_SOCAL_GAS_COMMERCIAL_OVERLAY_YEARS = new Set([2022, 2023, 2024]);

export function burbankSoCalGasResidentialOverlayYear(year: number): boolean {
  return BURBANK_SOCAL_GAS_RESIDENTIAL_OVERLAY_YEARS.has(year);
}

export function burbankSoCalGasCommercialOverlayYear(year: number): boolean {
  return BURBANK_SOCAL_GAS_COMMERCIAL_OVERLAY_YEARS.has(year);
}

/** @deprecated Use residential or commercial overlay helpers. */
export function burbankSoCalGasOverlayYear(year: number): boolean {
  return burbankSoCalGasCommercialOverlayYear(year);
}
